export default {
  title: "Пребарување",
  subtitle: "Пребарување на пациенти, примероци и резултати",
  comingSoon: "Наскоро",
  description:
    "Оваа функција ќе обезбеди сеопфатно пребарување на пациенти, примероци и резултати.",
};
